import { Allergy, AllergyReaction } from './allergy.model';
import { AllergicSubstance } from '../model/allergicSubstance';
import { Emphasis } from '../model/emphasis';
import { SourceType } from '../model/medicalComponent';

export type AllergyDraftFromCodes = {
  substanceCode: string;
  emphasis: Emphasis;
  reactionCodes?: string[];
  notes?: string;
};

export const buildAllergyFromCodes = (
  draft: AllergyDraftFromCodes,
  substances: AllergicSubstance[]
): Partial<Allergy> => {
  const matchedSubstance = substances.find(
    (s) => s.code === draft.substanceCode
  );
  const reactionByCode = new Map(
    (matchedSubstance?.allergicSubstanceReactions ?? []).map((r) => [r.code, r])
  );

  const reactions = draft.reactionCodes?.map((code) => {
    const managed = reactionByCode.get(code);
    return managed
      ? ({
          code,
          sourceType: SourceType.PREDEFINED,
          translationCode: managed.translationCode
        } as AllergyReaction)
      : ({
          code,
          sourceType: SourceType.DOCTOR_INPUT
        } as AllergyReaction);
  });

  return {
    substanceCode: draft.substanceCode,
    sourceType: matchedSubstance
      ? SourceType.PREDEFINED
      : SourceType.DOCTOR_INPUT,
    translationSubstanceCode: matchedSubstance?.translationCode,
    emphasis: draft.emphasis,
    notes: draft.notes,
    reactions
  };
};
